module.exports = __webpack_public_path__ + "img/accessory_hat_10.07928cf7.svg";